/**
 * Many adjustments to the element sizes and spacings in
 * the animation can be made by just changing these values.
 */

/** --------------- WRAPPER --------------- */

// Used to determine whether to use MW or Desktop animation values
export const WRAPPER_RATIO_MULTIPLIER = 0.6;

// Padding above card in final state * 2 (in px)
export const WRAPPER_PADDING_DESKTOP_LANDSCAPE = 360;
export const WRAPPER_PADDING_DESKTOP_PORTRAIT = 188;
export const WRAPPER_PADDING_MW = 48;

/** --------------- CARD --------------- */

// Transform scale of card in initial state
export const CARD_INITIAL_SCALE_LANDSCAPE = 0.63;
export const CARD_INITIAL_SCALE_PORTRAIT = 0.85;

// Aspect ratio of landscape and portrait cards
export const CARD_RATIO_LANDSCAPE = 0.73529412;
export const CARD_RATIO_PORTRAIT = 1.36;

/** --------------- ENVELOPE --------------- */

// Used to calculate the difference in initial card width and envelope width
export const ENVELOPE_CARD_OFFSET = 0.04;

// Envelope aspect ratios
export const ENVELOPE_RATIO = 1.23387097;
export const ENVELOPE_RATIO_CLOSED = 0.78225806;

// Transform scale of envelope in final state
export const ENVELOPE_FINAL_SCALE_LANDSCAPE = 0.85;
export const ENVELOPE_FINAL_SCALE_PORTRAIT = 1.05;
